import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FaDownload, FaRedoAlt } from 'react-icons/fa';
import { Button, EmptyState, Pill } from '../../components/EntityList';
import { FaInbox } from 'react-icons/fa';

const TYPE_LABELS = {
	estado_situacion: 'Estado Situación',
	ultimos_pagos_cuota_deuda: 'Últimos pagos por cuota de deuda',
};

const STATUS = {
	in_progress: { label: 'En proceso', tone: 'warn' },
	completed: { label: 'Listo', tone: 'ok' },
	failed: { label: 'Falló', tone: 'danger' },
};

function GeneratedReportsTable({ reports, loading, onRefresh, onDownload }) {
	return (
		<section className='tw:mt-7'>
			<div className='tw:mb-3 tw:flex tw:items-center tw:justify-between tw:gap-3'>
				<div>
					<h2 className='tw:m-0 tw:text-[15px] tw:font-semibold tw:text-ink-0'>Reportes generados</h2>
					<p className='tw:mt-1 tw:mb-0 tw:text-[12px] tw:text-ink-3'>Los archivos permanecen disponibles durante 48 horas.</p>
				</div>
				<Button size='sm' icon={<FaRedoAlt size={11} />} onClick={onRefresh} disabled={loading}>
					{loading ? 'Actualizando…' : 'Actualizar'}
				</Button>
			</div>
			<div className='tw:overflow-hidden tw:rounded-panel tw:border tw:border-border tw:bg-surface'>
				{reports.length === 0 ? (
					<EmptyState icon={<FaInbox />} title='Todavía no hay reportes' description='Los reportes pesados que solicites aparecerán acá.' />
				) : (
					<div className='tw:overflow-x-auto'>
						<table className='tw:w-full tw:border-collapse tw:text-[12.5px]'>
							<thead className='tw:bg-surface-2 tw:text-left tw:text-[11px] tw:uppercase tw:tracking-[0.05em] tw:text-ink-3'>
								<tr>
									<th className='tw:px-4 tw:py-3'>Fecha</th>
									<th className='tw:px-4 tw:py-3'>Tipo de reporte</th>
									<th className='tw:px-4 tw:py-3'>Solicitado por</th>
									<th className='tw:px-4 tw:py-3'>Estado</th>
									<th className='tw:px-4 tw:py-3 tw:text-right'>Archivo</th>
								</tr>
							</thead>
							<tbody>
								{reports.map((report) => {
									const status = STATUS[report.status] || { label: report.status, tone: 'neutral' };
									return (
										<tr key={report._id} className='tw:border-t tw:border-border'>
											<td className='tw:whitespace-nowrap tw:px-4 tw:py-3 tw:text-ink-2'>{moment(report.requestedAt).format('DD/MM/YYYY HH:mm')}</td>
											<td className='tw:px-4 tw:py-3 tw:font-medium tw:text-ink-0'>{TYPE_LABELS[report.reportType] || report.reportType}</td>
											<td className='tw:px-4 tw:py-3 tw:text-ink-2'>{report.requestedBy?.name || 'Usuario'}</td>
											<td className='tw:px-4 tw:py-3'>
												<Pill tone={status.tone} dot>{status.label}</Pill>
												{report.errorMessage && <div className='tw:mt-1.5 tw:max-w-[300px] tw:text-[11.5px] tw:text-danger'>{report.errorMessage}</div>}
											</td>
											<td className='tw:px-4 tw:py-3 tw:text-right'>
												{report.status === 'completed' ? (
													<button type='button' onClick={() => onDownload(report)} className='tw:inline-flex tw:items-center tw:gap-1.5 tw:border-0 tw:bg-transparent tw:p-0 tw:font-medium tw:text-accent tw:hover:underline'>
														<FaDownload size={11} /> Descargar
													</button>
												) : <span className='tw:text-ink-3'>—</span>}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</section>
	);
}

GeneratedReportsTable.propTypes = {
	reports: PropTypes.arrayOf(PropTypes.object).isRequired,
	loading: PropTypes.bool,
	onRefresh: PropTypes.func.isRequired,
	onDownload: PropTypes.func.isRequired,
};

export default GeneratedReportsTable;
